import React from 'react';
import PropTypes from 'prop-types';

import styles from './Loader.m.sass';
import loaderImg from './assets/spinner.svg';

import cx from 'classnames';

export default class Loader extends React.PureComponent {
  render() {
    const {inline, overlay, page, section, block} = this.props;

    if (inline) {
      return (
        <img
          className={cx(styles.loader, styles.loader__inline)}
          src={loaderImg}
          alt="Loading..."
        />
      );
    }

    return (
      <div
        className={cx(
          styles.loaderContainer,
          {
            [styles.loaderContainer__page]: page,
            [styles.loaderContainer__section]: section,
            [styles.loaderContainer__block]: block,
            [styles.loaderContainer__overlay]: overlay
          },
        )}
      >
        <img
          className={styles.loader}
          src={loaderImg}
          alt="Loading..."
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/loader/Loader.js